import Route from "../../../router/Route";
import { RouterView } from "vue-router";

import ExplorerLoadingWrapper from "../pages/ExplorerLoadingWrapper.vue";
import GraphWrapper from "@/modules/explorer/components/Graphs/GraphWrapper.vue";
import MetricsWrapper from "@/modules/explorer/components/Metrics/MetricsWrapper.vue";
import SingleMetricLayout from "@/modules/explorer/components/SingleMetric/SingleMetricLayout.vue";

export default new Route("explorer", "/explorer", RouterView, [
	new Route(
		"explorer.index",
		"",
		ExplorerLoadingWrapper,
		[
			new Route("explorer.graphWrapper", "graph", GraphWrapper, []),
			new Route("explorer.metricWrapper", "metrics", MetricsWrapper, []),
			new Route(
				"explorer.singleMetricWrapper",
				"single-metric",
				SingleMetricLayout,
				[]
			),
		],
		{},
		"/explorer/graph"
	),
]);
